import React, { useEffect, useMemo, useState } from "react";
import { Button, Input, Textarea } from "@nextui-org/react";
import { useNavigate, useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import Resizer from "react-image-file-resizer";

import axios from "axios";

import { inputStyle, inputWrapperStyle } from "../../data/inputStyleData";

import { useDispatch } from "react-redux";
import { refreshIfNeeded } from "../../store/actions/refreshIfNeeded";
import { removeAuth } from "../../store/slices/authSlice";

const DisputeDetails = () => {
  const {
    register,
    handleSubmit,
    reset,
    setValue,
    getValues,
    formState: { errors },
  } = useForm();

  const reasonData = JSON.parse(localStorage.getItem("reason_data") || "{}");
  const userId = JSON.parse(localStorage.getItem("user_id") || "null");
  const MAX_FILES = 5;

  const [previews, setPreviews] = useState([]);
  const [uploadFiles, setUploadFiles] = useState([]);

  const navigate = useNavigate();

  // // 🔐 always-latest token helpers
  // const authHeaders = () => ({
  //   headers: { Authorization: `Bearer ${localStorage.getItem("accessToken")}` },
  // });
  const ensureAuth = async () => {
    await dispatch(refreshIfNeeded());
    return authHeaders();
  };
  const { id } = useParams();
  const today = useMemo(() => new Date().toISOString().slice(0, 10), []);
  const dispatch = useDispatch();

  // Numeric id + label
  // const reasonId = useMemo(() => {
  //   // const candidate =
  //   //  reasonData?.reason_id ?? reasonData?.titleId ?? reasonData?.id ?? null;
  //   const candidate = reasonData?.title;
  //   console.log("🔎 Raw reasonData:", reasonData.title);
  //   console.log(
  //     "➡️ Picked candidate:",
  //     candidate,
  //     " (typeof:",
  //     typeof candidate,
  //     ")"
  //   );

  //   // const n = Number(candidate);

  //   const n = Number.isFinite(candidateNumber);
  //   console.log("➡️ Converted to number:", n);

  //   const isValid = Number.isFinite(n);
  //   console.log("✅ Is finite number?", isValid);

  //   return isValid ? n : null;
  // }, [reasonData]);

  let reasonId = null;

if (reasonData?.title) {
  console.log("🔎 Raw reasonData.title:", reasonData.title);

  const candidate = reasonData.title;
  console.log("➡️ Picked candidate:", candidate, " (typeof:", typeof candidate, ")");

  const candidateNumber = Number(candidate);
  console.log("➡️ Converted to number:", candidateNumber);

  const isValid = Number.isFinite(candidateNumber);
  console.log("✅ Is finite number?", isValid);

  reasonId = isValid ? candidateNumber : null;
}

console.log("🎯 Final reasonId:", reasonId);


  const reasonLabel =
    reasonData?.titleReason || reasonData?.reason || reasonData?.label || "";
  console.log("📝 Computed reasonLabel:", reasonLabel);
  // Auth helpers
  const authHeaders = () => ({
    headers: { Authorization: `Bearer ${localStorage.getItem("accessToken")}` },
  });
  // const ensureAuth = async () => {
  //   await dispatch(refreshIfNeeded());
  //   return authHeaders();
  // };

  const removeImage = (index) => {
    setPreviews((prev) => {
      try {
        URL.revokeObjectURL(prev[index]?.url);
      } catch {}
      return prev.filter((_, i) => i !== index);
    });
    setUploadFiles((prev) => prev.filter((_, i) => i !== index));
  };

  const uploadImage = async (e) => {
    const picked = Array.from(e.target.files || []);
    const remaining = MAX_FILES - uploadFiles.length;
    if (remaining <= 0) {
      toast.info(`You already selected ${MAX_FILES}/${MAX_FILES}.`);
      return;
    }
    const files = picked.slice(0, remaining);
    if (picked.length > remaining) {
      toast.warn(`Only ${remaining} more image(s) allowed (max ${MAX_FILES}).`);
    }

    const resizedList = await Promise.all(
      files.map(
        (file) =>
          new Promise((resolve) => {
            Resizer.imageFileResizer(
              file,
              800,
              800,
              "JPEG",
              80,
              0,
              (blob) => resolve(blob),
              "file"
            );
          })
      )
    );

    setUploadFiles((prev) => [...prev, ...resizedList]);

    const now = Date.now();
    const previewObjects = resizedList.map((f, i) => ({
      id: `${now}-${i}-${Math.random()}`,
      url: URL.createObjectURL(f),
    }));
    setPreviews((prev) => [...prev, ...previewObjects]);
  };

  const onSubmit = async (data) => {
    try {
      const titleNum = Number(getValues("title") ?? reasonId);
      if (!Number.isFinite(titleNum)) {
        toast.error("Invalid reason. Please pick a reason again.");
        return;
      }

      const fd = new FormData();
      console.log("title form ", titleNum);
      fd.append("title", String(titleNum)); // ✅ numeric
      fd.append("received_date", data.received_date);
      fd.append("description", data.description);
      fd.append("user_id", userId);
      uploadFiles.forEach((f) => fd.append("images[]", f));

      const headers = await ensureAuth();
      console.log("📌 Dispute.create payload:", fd);
      const res = await axios.post(
        `${process.env.REACT_APP_SERVER_URL}/orders/${id}/dispute`,
        fd,
        headers
      );
      toast.success(res.data?.message);
      setTimeout(() => navigate("/quotes"), 700);
    } catch (err) {
      toast.error(err.response?.data?.message || "Something went wrong");
      if (err?.response?.status === 401) {
        localStorage.clear();
        dispatch(removeAuth());
        navigate("/login");
      }
    }
  };

  useEffect(() => {
    if (reasonId != null) setValue("title", reasonId, { shouldValidate: true });
    console.log("title", reasonId);
  }, [reasonId, setValue]);

  return (
    <div className="sm:px-4 pt-2 pb-5">
      <p className="font-semibold border-b-1 border-gray-300 pb-2 mb-5">
        Submit the details of order
      </p>

      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="sm:grid block sm:grid-cols-2 gap-5 mb-5">
          <div className="mb-5">
            <Input
              type="date"
              label="Received Order Date"
              variant="bordered"
              labelPlacement="outside"
              className="w-full text-black"
              min={today}
              {...register("received_date", {
                required: "Enter the receiving date",
                validate: (v) => v >= today || "Date cannot be in the past",
              })}
            />
            {errors.received_date && (
              <p className="text-xs text-red-400">
                {errors.received_date.message}
              </p>
            )}
          </div>

          <Input
            isReadOnly
            className="mb-5"
            label="Make"
            variant="bordered"
            labelPlacement="outside"
            value={reasonData.make || reasonData.custom_make || ""}
          />
          <Input
            isReadOnly
            className="mb-5"
            label="Model"
            variant="bordered"
            labelPlacement="outside"
            value={reasonData.model || reasonData.custom_model || ""}
          />
          <Input
            isReadOnly
            className="mb-5"
            label="Part"
            variant="bordered"
            labelPlacement="outside"
            value={reasonData.part || ""}
          />

          <div className="mb-5">
            <Input
              type="file"
              label={`Upload images (Max ${MAX_FILES})`}
              classNames={{
                input: inputStyle,
                inputWrapper: inputWrapperStyle,
              }}
              multiple
              accept="image/*"
              labelPlacement="outside"
              onChange={uploadImage}
              isDisabled={uploadFiles.length >= MAX_FILES}
            />
            <p className="text-xs text-gray-500 mt-1">
              {uploadFiles.length}/{MAX_FILES} selected{" "}
              {uploadFiles.length >= MAX_FILES ? "— Limit reached" : ""}
            </p>
          </div>
        </div>

        <p className="font-semibold border-b-1 border-gray-300 pb-2 mb-5">
          A brief note about reason
        </p>

        {/* Show label only */}
        <Input
          isReadOnly
          type="text"
          label="Reason"
          variant="bordered"
          labelPlacement="outside"
          className="w-full text-black"
          value={reasonLabel}
        />
        {/* hidden numeric field for API */}
        <input
          type="hidden"
          {...register("title", { required: true, valueAsNumber: true })}
        />

        <Textarea
          variant="bordered"
          label="Description"
          labelPlacement="outside"
          placeholder="Enter your description"
          className="mt-5"
          minRows={4}
          {...register("description", { required: true })}
        />
        {errors.description && (
          <p className="text-xs text-red-400">Enter detail description</p>
        )}

        <div className="flex justify-end">
          <Button
            type="submit"
            className="bg-lightBlue text-white py-1 px-10 mt-6"
          >
            Submit
          </Button>
        </div>
      </form>
    </div>
  );
};

export default DisputeDetails;
